/**
 * ru-vocab-report.js — сертификат и разбор теста словарного запаса (PDF).
 *
 * Карточку рисует ОБЩИЙ примитив <x-perk-gate perk="vocab_report"> (+ perk-gate.js):
 * план заголовком, разовая оплата 99 ₽ второй строкой, токены там, где план уже
 * израсходован. Этот файл делает только то, что знает тул:
 *   • переносит карточку под итог на экране результата (её тексты и цены
 *     серверные, поэтому элемент ПЕРЕЕЗЖАЕТ, а не собирается заново);
 *   • поле «Имя для сертификата»;
 *   • park()  — отложить прогон на сервере при первом признаке намерения;
 *   • issue() — выдать документ вошедшему (перк плана или токены решает сервер);
 *   • возврат из кассы `?rvt_paid=<прогон>` — забрать оплаченное.
 *
 * ⚠️ В браузере НЕТ ни одной цифры документа: сервер получает ответы
 * ([id задания, ответ]) и пересчитывает прогон сам (VocabTestScorer). Код
 * проверки на сертификате заверяет наш пересчёт, а не содержимое запроса.
 *
 * ES2018-safe, обычный скрипт (defer): его зовёт ESM-приложение тула.
 */
(function () {
'use strict';

var PERK = 'vocab_report';
var RESULT = null;      // результат движка (нужны answers и durMs)
var RUN = null;         // {ref, token} отложенного прогона
var RUN_NAME = null;    // имя, с которым прогон отложен
var PARKING = null;
var CLAIMED = false;

function T(key) {
    var d = (window.__RVT && window.__RVT.T) || {};
    return typeof d[key] === 'string' ? d[key] : '';
}
function esc(s) {
    return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) {
        return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
}
function ae(stage, extra) {
    try { window.__aeFunnel && window.__aeFunnel(stage, extra || {}); } catch (e) {}
}
function csrf() {
    var m = document.querySelector('meta[name="csrf-token"]');
    return m ? m.getAttribute('content') : '';
}

/* ⚠️ Анонимному страница приходит из кэша с ЧУЖИМ токеном и без сессионной
 * куки — первый POST ловит 419. Ждём общий __csrfReady(). */
function post(url, body) {
    var ready = (typeof window.__csrfReady === 'function') ? window.__csrfReady() : Promise.resolve(null);
    return ready.then(function () {
        return fetch(url, {
            method: 'POST',
            credentials: 'same-origin',
            headers: {
                'Content-Type': 'application/json',
                'Accept': 'application/json',
                'X-Requested-With': 'XMLHttpRequest',
                'X-CSRF-TOKEN': csrf()
            },
            body: JSON.stringify(body || {})
        }).then(function (r) {
            return r.json().catch(function () { return {}; }).then(function (j) {
                j = j || {};
                j.__status = r.status;
                return j;
            });
        });
    });
}

function locale() { return window.__LOCALE || document.documentElement.lang || 'ru'; }
function gate() { return document.querySelector('[data-perk-gate][data-perk="' + PERK + '"]'); }
function nameValue() {
    var el = document.getElementById('rvtCertName');
    return el ? String(el.value || '').trim().slice(0, 60) : '';
}

function status(msg, kind) {
    var el = document.getElementById('rvtCertStatus');
    if (!el) return;
    el.textContent = msg || '';
    el.className = 'rvt-cert-status' + (kind ? ' ' + kind : '');
    el.hidden = !msg;
}

/* ── прогон на сервере ────────────────────────────────────────────────── */

/**
 * Отложить прогон ОДИН раз — при намерении, а не на показ (показов тысячи в
 * месяц, и хранить ответы тех, кто ничего не просил, незачем). Без прогона
 * вебхуку нечего выдавать после оплаты.
 */
function park() {
    if (!RESULT || !RESULT.answers) return Promise.resolve(null);
    if (RUN) return Promise.resolve({ ref: RUN.ref, token: RUN.token, name: nameValue() });
    if (PARKING) return PARKING;

    RUN_NAME = nameValue();
    /* Ответ, пришедший после нового результата (mount сбросил RUN/PARKING,
     * пока шёл запрос), описывает ПРЕЖНИЙ — присвоить его значило бы продать
     * новый результат по чужому прогону. */
    var forResult = RESULT;
    var mine = PARKING = post('/api/vocab-report/run', {
        items: RESULT.answers,
        dur_ms: RESULT.durMs || null,
        holder_name: RUN_NAME,
        locale: locale()
    }).then(function (j) {
        if (PARKING === mine) PARKING = null;
        if (!j || !j.ok) return null;
        ae('cert_run_saved', { ref: j.ref });
        if (RESULT !== forResult) return null;
        RUN = { ref: j.ref, token: j.token };
        return { ref: j.ref, token: j.token, name: RUN_NAME };
    }).catch(function () { if (PARKING === mine) PARKING = null; return null; });

    return mine;
}

/** Выдать документ вошедшему. Бесплатно по перку или за токены — решает сервер. */
function issue() {
    if (!RESULT || !RESULT.answers) return Promise.resolve({ ok: false, error: 'no_result' });
    return post('/api/vocab-report', {
        items: RESULT.answers,
        dur_ms: RESULT.durMs || null,
        holder_name: nameValue(),
        locale: locale()
    }).then(function (j) {
        if (!j || !j.ok) return { ok: false, error: (j && j.error) || 'failed' };
        return { ok: true, download: j.download, certified: j.certified };
    }).catch(function () { return { ok: false, error: 'network' }; });
}

/**
 * Забираем файл через blob и общий примитив: прямой переход увёл бы со
 * страницы результата, а <a download> на blob молча не работает в Android
 * WebView (за это отвечает __downloadFile).
 */
function download(url, certified) {
    fetch(url, { credentials: 'same-origin' })
        .then(function (r) { return r.ok ? r.blob() : Promise.reject(r.status); })
        .then(function (blob) {
            var name = (certified ? 'sertifikat-slovarnyy-zapas' : 'razbor-slovarnyy-zapas') + '.pdf';
            if (window.__downloadFile) window.__downloadFile(blob, name);
            else window.location.href = url;
        })
        .catch(function () { window.location.href = url; });
}

function renderIssued(url, certified) {
    status(T('cert_ready'), 'ok');
    var again = document.getElementById('rvtCertAgain');
    if (again) {
        again.hidden = false;
        again.onclick = function () { download(url, certified); };
    }
}

/* ── экран результата ─────────────────────────────────────────────────── */

function slotHtml(r) {
    var note = r && r.reliable === false && T('cert_uncertified')
        ? '<p class="rvt-cert-note">' + esc(T('cert_uncertified')) + '</p>' : '';
    return '<div class="rvt-cert">'
        + note
        + '<label class="rvt-cert-lbl" for="rvtCertName">' + esc(T('cert_name_label')) + '</label>'
        + '<input class="rvt-cert-in" id="rvtCertName" type="text" maxlength="60" autocomplete="name"'
        + ' placeholder="' + esc(T('cert_name_hint')) + '">'
        + '<div class="rvt-cert-gate" id="rvtCertGateSlot"></div>'
        + '<div class="rvt-cert-status" id="rvtCertStatus" role="status" hidden></div>'
        + '<button type="button" class="rvt-btn ghost rvt-cert-again" id="rvtCertAgain" hidden>' + esc(T('cert_again')) + '</button>'
        + '</div>';
}

/** Карточка переезжает в слот результата — и обратно домой перед перерисовкой панели. */
function relocate() {
    var g = gate();
    var slot = document.getElementById('rvtCertGateSlot');
    if (g && slot && g.parentNode !== slot) slot.appendChild(g);
}
function unmount() {
    var g = gate();
    var home = document.getElementById('rvtGateHome');
    if (g && home && g.parentNode !== home) home.appendChild(g);
}

var registered = false;
function register() {
    if (registered || !window.__perkGate) return;
    registered = true;
    window.__perkGate.register(PERK, {
        park: park,
        issue: issue,
        onIssued: function (res) {
            if (res && res.download) {
                ae('cert_issued', { certified: res.certified ? 1 : 0 });
                download(res.download, res.certified);
                renderIssued(res.download, res.certified);
            }
        }
    });
}

function mount(r) {
    // Модуль выключен (vocab-report.enabled) — экран результата живёт без карточки.
    if (!(window.__RVT && window.__RVT.cfg && window.__RVT.cfg.report)) return;
    RESULT = r || null;
    RUN = null;
    RUN_NAME = null;
    PARKING = null;
    var host = document.getElementById('rvtOfferSlot');
    if (!host || !RESULT || !RESULT.answers) return;
    host.innerHTML = slotHtml(RESULT);
    relocate();
    register();
    // Новый результат — новый контекст: прежний отложенный прогон к нему не относится.
    try { window.__perkGate && window.__perkGate.setContext(PERK, {}); } catch (e) {}

    /* Имя, вписанное ПОСЛЕ откладывания прогона, обязано доехать до
     * назначения платежа: иначе оплаченный сертификат выйдет без имени. */
    var input = document.getElementById('rvtCertName');
    if (input) {
        input.addEventListener('change', function () {
            if (!RUN || !window.__perkGate) return;
            window.__perkGate.setContext(PERK, { ref: RUN.ref, token: RUN.token, name: nameValue() });
        });
    }
}

/* ── возврат из кассы ─────────────────────────────────────────────────── */

/**
 * `?rvt_paid=<прогон>`: документ к этому моменту почти всегда собран
 * вебхуком — забираем его сами, чтобы человек ПОЛУЧИЛ файл, а не искал.
 * Работает БЕЗ результата на экране: заплативший с телефона, в приватном
 * окне или через сутки видит обычный стартовый экран.
 */
function claimPaid() {
    var m = /[?&]rvt_paid=(\d+)/.exec(window.location.search || '');
    if (!m || CLAIMED) return;
    CLAIMED = true;

    // Адрес чистим сразу: перезагрузка не должна выглядеть как вторая покупка.
    try {
        var clean = window.location.pathname
            + window.location.search.replace(/([?&])rvt_paid=\d+&?/, '$1').replace(/[?&]$/, '');
        window.history.replaceState({}, '', clean);
    } catch (e) {}

    var box = document.getElementById('rvtPaidNotice');
    var say = function (msg, kind) {
        if (!box) return;
        box.textContent = msg;
        box.className = 'rvt-paid-notice' + (kind ? ' ' + kind : '');
        box.hidden = !msg;
    };

    ae('cert_paid_return', { ref: m[1] });
    say(T('cert_claiming'));

    post('/api/vocab-report/claim', { ref: +m[1] }).then(function (j) {
        if (j && j.ok && j.download) {
            say(T('cert_ready'), 'ok');
            download(j.download, j.certified);
            return;
        }
        /* Не вошёл (аккаунт на эту почту уже был — касса в него не входит)
         * или прогон не его: документ уже ушёл письмом со ссылкой. Говорим
         * это прямо, а не «ошибка». */
        say(T('cert_emailed'));
    }).catch(function () { say(T('cert_emailed')); });
}

if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', claimPaid);
} else {
    claimPaid();
}

window.RVTReport = { mount: mount, unmount: unmount };
})();
